<script>
    import MediaPackageContent from './MediaPackageContent.vue';

    export default {
        components: {
            'media-package-content': MediaPackageContent
        },
        model: {
            prop: 'package',
            event: 'set-package'
        },
        props: {
            countVisible: {
                default: 3
            },
            width: {
                default: 35
            },
            height: {
                default: 35
            },
            package: {
                type: Object,
                default: null
            }
        },
        computed: {
            visibles() {
                return this.package.contents.slice(0, this.countVisible);
            },
            countInvisible() {
                return Math.max(0, this.package.contents.length - this.countVisible);
            }
        }
    }
</script>
<template>
    <div class="package-image-preview">
        <!--<a :href="content.content.pimUrl">-->
        <template v-for="content in visibles">

            <media-package-content
                    v-model="package"
                    class="inline">
                <a slot="opener">
                    <img alt="image" class="img-circle" :width="width" :height="height" :src="content.content.previewImageUrl">
                </a>
            </media-package-content>

        </template>

        <media-package-content
                v-model="package"
                class="inline">
            <a slot="opener">
                <div v-if="countInvisible > 0" class="badge badge-primary" v-text="'+' + countInvisible"></div>
            </a>
        </media-package-content>

    </div>
</template>